"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GridV4FuturesProcessor = exports.GridV4FuturesMaxGrids = exports.GridV4FuturesMinGrids = exports.PriceCoefficient = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const react_1 = require("react");
const GridTradingUtils_1 = require("../GridTradingUtils");
const trade_utils_lib_1 = require("trade_utils_lib");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const _1 = require("./");
const useAdjustParamsCheckInfo_1 = require("./Hooks/useAdjustParamsCheckInfo");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const GFModeUtils_1 = require("./Hooks/GFModeUtils");
const Hooks_1 = require("./Hooks");
// 价格的加权系数
exports.PriceCoefficient = 1.02;
exports.GridV4FuturesMinGrids = 2; // 合约网格最小格子数
exports.GridV4FuturesMaxGrids = 500; // 合约网格最大格子数
const USDT = "USDT";
var GridV4FuturesProcessor;
(function (GridV4FuturesProcessor) {
    function useUserParams(props) {
        var _a, _b, _c, _d, _e;
        const { triggerPrice, currentPrice, symbolInfo, symbolDisplay, gridType, top, bottom, count, tradeAPI, leverage, botType, invest: input_invest, quoteAvailable, trend, extraMargin, extraMarginAmount: _extraMarginAmount, takeProfitPrice, takeProfitLimitPrice, stopLostPrice, stopLostLimitPrice, stopLostHighPrice, stopLostLimitHighPrice, takeProfitDelay, stopLostDelay, slStopType, tpStopType, movingInfo, $st, invest_coin, ui_invest_coin, aiSlippage, enableSlippage = true, isActive = true, is_copy_bot = false, mode = TradeAPILib_1.GridFuturesMode.normal, } = props;
        // 如果是非USDT的币对, quote / USDT 的信息
        const quoteToUInfo = GridV4FuturesProcessor.useQuoteToUInfo({ symbol: symbolInfo, investCoin: invest_coin, mode }, isActive);
        // 参数处理
        const realAndDisplayParams = GFModeUtils_1.GFModeUtils.useRealAndDisplayParams({
            mode,
            trend,
            top,
            bottom,
            currentPrice,
            triggerPrice,
            symbolInfo,
            symbolDisplay,
            stopLossType: slStopType,
            stopLostPrice,
            stopLostHighPrice,
            stopLostLimitHighPrice,
            stopLostLimitPrice,
            takeProfitType: tpStopType,
            takeProfitPrice,
            takeProfitLimitPrice,
        });
        const { trendReal, topReal, bottomReal, triggerReal, stopLostPriceReal, takeProfitPriceReal, stopLostLimitHighPriceReal, stopLostHighPriceReal, stopLostLimitPriceReal, takeProfitLimitPriceReal, currentPriceDisplay, } = realAndDisplayParams;
        // 实际的该币对的投资额 例:如果EB投U,传入的_invest是U,那这里转换成quote为BTC
        const processSymbolInvest = (0, react_1.useCallback)((value) => {
            var _a;
            if (!value) {
                return "";
            }
            if (quoteToUInfo.needTransfer) {
                const quoteToUPrice = quoteToUInfo.quoteToUPrice;
                if (quoteToUPrice) {
                    return new trade_utils_lib_1.SafeDecimal(value)
                        .div(new trade_utils_lib_1.SafeDecimal(quoteToUPrice))
                        .toDP((_a = symbolInfo.precisionCost) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_DOWN)
                        .toFixed();
                }
                return "";
            }
            return value;
        }, [quoteToUInfo.needTransfer, quoteToUInfo.quoToUSymbol, quoteToUInfo.quoteToUPrice, symbolInfo.precisionCost]);
        // 投资额, 手动额外保证金
        const [invest, extraMarginAmount] = (0, react_1.useMemo)(() => {
            const i = processSymbolInvest(input_invest);
            const e = !extraMargin ? processSymbolInvest(_extraMarginAmount) : undefined;
            return [i, e];
        }, [processSymbolInvest, input_invest, extraMargin, _extraMarginAmount]);
        // 如果quote不是USDT的币对，又是投U的状态, 此参数会将U转换成原本的quote的可用余额。
        // 例如ETH/BTC，投U，quoteAvailable为1000 USDT，则此参数为 1000 / BTC的价格
        const convertQuoteAvail = (0, react_1.useMemo)(() => {
            var _a;
            if (quoteToUInfo.needTransfer) {
                // 价格上浮冗余
                return new trade_utils_lib_1.SafeDecimal(quoteAvailable)
                    .div(new trade_utils_lib_1.SafeDecimal(quoteToUInfo === null || quoteToUInfo === void 0 ? void 0 : quoteToUInfo.quoteToUPrice))
                    .toDP((_a = symbolInfo.precisionCost) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_DOWN)
                    .toFixed();
            }
            return quoteAvailable;
        }, [quoteToUInfo.needTransfer, quoteToUInfo === null || quoteToUInfo === void 0 ? void 0 : quoteToUInfo.quoteToUPrice, quoteAvailable]);
        const [fee, feeError] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbolInfo, tradeAPI, TradeAPILib_1.ExchangeID.PIONEXV2, "maker");
        const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid(gridType, top, bottom, count, fee, (_a = symbolInfo.precision) !== null && _a !== void 0 ? _a : 0);
        const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(top, bottom, gridType, fee, (_b = symbolInfo.precision) !== null && _b !== void 0 ? _b : 0, exports.GridV4FuturesMaxGrids);
        const checkPriceError = () => {
            return GridTradingUtils_1.GridTradingUtils.checkPriceError(bottomReal, topReal, $st, trendReal, currentPrice, mode);
        };
        const tradeInfoRequest = {
            base: symbolInfo.base,
            quote: symbolInfo.quote,
            trend: trendReal,
            top: topReal,
            bottom: bottomReal,
            row: Number(count || 0),
            grid_type: gridType,
            leverage: leverage,
            extra_margin: extraMargin,
            extra_margin_amount: extraMarginAmount ? extraMarginAmount : "0",
            quote_investment: invest,
            user_investment: input_invest,
            open_price: triggerReal || currentPrice,
            invest_precision: (_c = symbolInfo.precisionCost) !== null && _c !== void 0 ? _c : 0,
            price_precision: (_d = symbolDisplay === null || symbolDisplay === void 0 ? void 0 : symbolDisplay.precision) !== null && _d !== void 0 ? _d : 0,
            is_copy_bot,
            transToMode: mode,
        };
        const { tradeInfo, queryNewTradeInfo, loading: tradeInfoLoading } = (0, Hooks_1.useGridV4FuturesTradeInfo)(tradeInfoRequest);
        const [minInvest, maxInvest] = (0, react_1.useMemo)(() => {
            return processInputInvestRange(symbolInfo, tradeInfo, quoteToUInfo);
        }, [quoteToUInfo, symbolInfo, tradeInfo]);
        const investState = (0, react_1.useMemo)(() => {
            const state = {
                state: "normal",
                min: minInvest,
                max: maxInvest,
            };
            const i = (() => {
                if (quoteToUInfo.needTransfer) {
                    // 拿输入的U去比较
                    return input_invest;
                }
                else {
                    return invest;
                }
            })();
            if (i) {
                if (new trade_utils_lib_1.SafeDecimal(i).greaterThan(new trade_utils_lib_1.SafeDecimal(state.max))) {
                    state.state = "large";
                }
                else if (new trade_utils_lib_1.SafeDecimal(i).lessThan(new trade_utils_lib_1.SafeDecimal(state.min))) {
                    state.state = "small";
                }
            }
            return state;
        }, [input_invest, invest, maxInvest, minInvest, quoteToUInfo.needTransfer]);
        const emptyErrors = (0, react_1.useMemo)(() => {
            const emptys = GridTradingUtils_1.GridTradingUtils.checkRequiredParamsEmpty(top, bottom, count);
            if (!Number(invest)) {
                emptys.push("trade_investment");
            }
            return emptys;
        }, [top, bottom, count, invest]);
        const enableCreateOrder = (() => {
            const priceDisable = !top || !bottom || Number(bottom) >= Number(top);
            const gridsDisable = !count || Number(count) < 2 || Number(count) > calcuGridsMax;
            const investDisable = !invest || investState.state !== "normal";
            const leverageDisable = !leverage;
            return !priceDisable && !gridsDisable && !investDisable && !leverageDisable;
        })();
        const basicParams = {
            botType,
            top: topReal,
            bottom: bottomReal,
            count,
            invest,
            gridType,
            baseAvailable: "",
            quoteAvailable: convertQuoteAvail,
            trend: trendReal,
            useAllCoins: false,
            triggerPrice: triggerReal || "",
            stopLostPrice: stopLostPriceReal || "",
            stopLostLimitPrice: stopLostLimitPriceReal,
            stopLostHighPrice: stopLostHighPriceReal || "",
            stopLostLimitHighPrice: stopLostLimitHighPriceReal,
            slStopType: slStopType || TradeAPILib_1.GridStopType.price,
            takeProfitPrice: takeProfitPriceReal || "",
            takeProfitLimitPrice: takeProfitLimitPriceReal,
            tpStopType: tpStopType || TradeAPILib_1.GridStopType.price,
            currentPrice: currentPrice,
            symbol: symbolInfo,
            openPriceLimit: "",
            fee,
            calculateFee: fee,
            feeError,
            emptyErrors,
            investState,
            profitPerGrid,
            totalAvailable: convertQuoteAvail,
            maxGrids: exports.GridV4FuturesMaxGrids,
            realMaxGrids: calcuGridsMax,
            investPercent: 0,
            earnCoin: symbolInfo.quote,
            earnCoinDisplay: symbolInfo.quoteDisplay,
            earnPrecision: (_e = symbolInfo.precisionCost) !== null && _e !== void 0 ? _e : 0,
            minInvest: minInvest,
            mode,
        };
        const getRequestInfo = () => {
            // 先屏蔽以 非 USDT, 非 BTC 报价的币对的下单
            if (symbolInfo.quote !== "USDT" && symbolInfo.quote !== "BTC" && symbolInfo.quote !== "ETH" && symbolInfo.quote !== "SOL") {
                return (0, rxjs_1.throwError)(() => {
                    return {
                        code: 100101,
                        message: "Not support this symbol pair, use USDT quote symbol please. This pair will support soon",
                    };
                });
            }
            const priceRangeError = checkPriceError();
            if (priceRangeError) {
                return (0, rxjs_1.throwError)(() => priceRangeError);
            }
            return queryNewTradeInfo().pipe((0, operators_1.map)((newTradeInfo) => {
                var _a;
                const { min, max } = processOriginInvestRange(newTradeInfo, basicParams.quoteAvailable, basicParams.symbol.precisionCost || 0);
                basicParams.minInvest = min;
                const baseRequest = GridTradingUtils_1.GridTradingUtils.checkCommonParamsByLocal(basicParams, $st);
                // 判断交易限制，交易额是否过大
                if (new trade_utils_lib_1.SafeDecimal(invest).greaterThan(new trade_utils_lib_1.SafeDecimal(max))) {
                    const errorStr = $st("trade_invest_need") + " ≤ " + max + ` ${symbolInfo.quote}`;
                    throw errorStr;
                }
                // 基于用户投的币种。打开了自动投入，就没有额外的保证金投入了，就都是invest。
                const totalInvest = new trade_utils_lib_1.SafeDecimal(input_invest).add(new trade_utils_lib_1.SafeDecimal(extraMargin ? 0 : _extraMarginAmount));
                // 判断余额是否足够
                if (totalInvest.greaterThan(new trade_utils_lib_1.SafeDecimal(quoteAvailable))) {
                    throw $st("trade_error_balance_not_enough");
                }
                baseRequest.leverage = new trade_utils_lib_1.SafeDecimal(leverage).toString();
                baseRequest.base_total_investment = "0";
                baseRequest.quote_total_investment = newTradeInfo.estimateTradeInvest;
                baseRequest.extra_margin = newTradeInfo.estimateMarginInvest;
                if (ui_invest_coin) {
                    baseRequest.ui_invest_coin = ui_invest_coin;
                }
                const isCM = mode === TradeAPILib_1.GridFuturesMode.coin_m;
                const isNoTrend = basicParams.trend === TradeAPILib_1.GridFuturesTrend.no_trend;
                // 使用后端的EB投U
                if (invest_coin && quoteToUInfo.needTransfer) {
                    baseRequest.invest_coin = invest_coin;
                    if (extraMargin) {
                        const [resInvestU, resExtraMarginU] = GridV4FuturesProcessor.getInvestAndExtraMarginBaseU(newTradeInfo, input_invest, (_a = quoteToUInfo.quoToUSymbol) === null || _a === void 0 ? void 0 : _a.precisionCost);
                        baseRequest.quote_total_investment = resInvestU;
                        baseRequest.extra_margin = trade_utils_lib_1.SafeDecimal.max(new trade_utils_lib_1.SafeDecimal(resExtraMarginU), 0).toFixed();
                    }
                    else {
                        baseRequest.quote_total_investment = input_invest;
                        baseRequest.extra_margin = _extraMarginAmount || "0";
                    }
                }
                const isSLByPrice = basicParams.slStopType === TradeAPILib_1.GridStopType.price || basicParams.slStopType === TradeAPILib_1.GridStopType.price_limit;
                // 币本位中性网格止损
                if (isCM && isNoTrend && isSLByPrice) {
                    // 上涨止损触发价
                    if (stopLostHighPriceReal) {
                        baseRequest.loss_stop = stopLostHighPriceReal;
                    }
                    // 上涨止损平仓价
                    if (stopLostLimitHighPriceReal) {
                        baseRequest.loss_stop_limit_price = stopLostLimitHighPriceReal;
                    }
                    // 下跌止损触发价
                    if (stopLostPriceReal) {
                        baseRequest.loss_stop_high = stopLostPriceReal;
                    }
                    // 下跌止损平仓价
                    if (stopLostLimitPriceReal) {
                        baseRequest.loss_stop_limit_high_price = stopLostLimitPriceReal;
                    }
                }
                else {
                    if (stopLostPrice || (isNoTrend && stopLostHighPrice)) {
                        baseRequest.loss_stop_type = slStopType;
                        baseRequest.loss_stop_high = stopLostHighPriceReal;
                        if (slStopType === TradeAPILib_1.GridStopType.profit_ratio || slStopType === TradeAPILib_1.GridStopType.profit_amount) {
                            baseRequest.loss_stop = stopLostPrice;
                            // 中性网格 止损设置 价格上限字段 只支持 按价格模式
                            baseRequest.loss_stop_high = undefined;
                        }
                    }
                }
                if (takeProfitPrice) {
                    baseRequest.profit_stop_type = tpStopType;
                }
                if (!new trade_utils_lib_1.SafeDecimal(takeProfitDelay).equals(0)) {
                    baseRequest.profit_stop_delay = takeProfitDelay;
                }
                if (!new trade_utils_lib_1.SafeDecimal(stopLostDelay).equals(0)) {
                    baseRequest.loss_stop_delay = stopLostDelay;
                }
                if (baseRequest.trend !== TradeAPILib_1.GridFuturesTrend.no_trend && enableSlippage) {
                    baseRequest.slippage = aiSlippage || (tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.slippage);
                }
                if (movingInfo && !new trade_utils_lib_1.SafeDecimal(movingInfo.movingTrailingUpParam).equals(0)) {
                    baseRequest.moving_indicator_type = movingInfo.movingIndicatorType;
                    baseRequest.moving_indicator_interval = movingInfo.movingIndicatorInterval;
                    baseRequest.moving_indicator_param = movingInfo.movingIndicatorParam;
                    baseRequest.moving_trailing_up_param = movingInfo.movingTrailingUpParam;
                }
                // 币本位处理
                if (isCM) {
                    baseRequest.ui_extra_data = JSON.stringify({ mode: mode });
                }
                return { request: baseRequest, tradeInfo: newTradeInfo };
            }));
        };
        const [liquidationPrice, liquidationPriceDisplay] = (0, react_1.useMemo)(() => {
            let liqui = undefined;
            let liquiDisplay = undefined;
            if (trend === "long") {
                liquiDisplay = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_down_display;
            }
            else {
                liquiDisplay = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_up_display;
            }
            if (trendReal === "long") {
                liqui = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_down;
            }
            else {
                liqui = tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_up;
            }
            return [liqui, liquiDisplay];
        }, [
            tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_down,
            tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_down_display,
            tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_up,
            tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.estimate_liquidation_price_up_display,
            trend,
            trendReal,
        ]);
        return Object.assign(Object.assign(Object.assign({}, basicParams), realAndDisplayParams), { top,
            bottom,
            trend, triggerPrice: triggerPrice || "", stopLostPrice: stopLostPrice || "", stopLostLimitPrice: stopLostLimitPrice, stopLostHighPrice: stopLostHighPrice || "", stopLostLimitHighPrice: stopLostLimitHighPrice, takeProfitPrice: takeProfitPrice || "", takeProfitLimitPrice: takeProfitLimitPrice, currentPrice,
            mode, symbolDisplay: symbolDisplay, maxInvest: maxInvest, enableCreate: enableCreateOrder, leverage: leverage, tradeInfo: tradeInfo, checkPriceError: checkPriceError, tradeInfoLoading: tradeInfoLoading, liquidationPrice: liquidationPrice, liquidationPriceDisplay: liquidationPriceDisplay, getRequestInfo, quoteToUInfo: quoteToUInfo });
    }
    GridV4FuturesProcessor.useUserParams = useUserParams;
    function calculateGridLiquidationPrice(params) {
        const { top, bottom, row, currentPrice, perVolume, trend, feeRate, gridType, assets, avgPrice, calculateLiquidation, baseAmount } = params;
        if (!Number(top) || !Number(bottom) || !Number(row) || Number(row) < 2 || Number(top) <= Number(bottom)) {
            return "";
        }
        if (!Number(perVolume) || !Number(currentPrice)) {
            return "";
        }
        const perVolumeD = new trade_utils_lib_1.SafeDecimal(perVolume);
        /** 初始开仓均价 */
        const avgPriceD = new trade_utils_lib_1.SafeDecimal(avgPrice);
        const feeRateD = new trade_utils_lib_1.SafeDecimal(feeRate);
        // 挂单数组 默认升序，价格从低到高
        const priceArr = GridTradingUtils_1.GridTradingUtils.getPriceInterverArr(top, bottom, row, gridType);
        if (priceArr.length <= 0) {
            return "";
        }
        // 开多降序 价格从高到低；开空升序，价格从低到高
        const isLong = trend === "long";
        const parseArr = trend === "long" ? priceArr.sort((a, b) => b.sub(a).toNumber()) : priceArr;
        // 当前价格所在的下标
        let curPriceIndex = 0;
        if (baseAmount) {
            curPriceIndex = new trade_utils_lib_1.SafeDecimal(baseAmount).abs().div(perVolume).toDecimalPlaces(0).toNumber();
        }
        else {
            curPriceIndex = GridTradingUtils_1.GridTradingUtils.findPriceIndexInArr(priceArr, currentPrice);
        }
        /**
         * 开多
         * 降序，从当前价格下边开始计算爆仓价 // i 为假设价格到了这个价位
         *
         * 开空
         * 升序，从当前价格上边开始计算爆仓价 // i 为假设价格到了这个价位
         */
        for (let i = curPriceIndex; i < parseArr.length; i++) {
            // 初始卖单价格加总
            let upperSumPrice = new trade_utils_lib_1.SafeDecimal(0);
            // 卖单个数
            let sellOrderCount = new trade_utils_lib_1.SafeDecimal(0);
            // 初始挂单量
            let totalBaseAmount = new trade_utils_lib_1.SafeDecimal(0);
            // 初始手续费
            let feeD = new trade_utils_lib_1.SafeDecimal(0);
            // 以下注释按做多为例
            // 从最高价开始计算平均持仓价格，当前价格之上用平均持仓价格，之下用订单价格本身买入
            for (let j = 0; j < i; j++) {
                sellOrderCount = sellOrderCount.add(1);
                totalBaseAmount = totalBaseAmount.add(perVolumeD);
                if (j < curPriceIndex) {
                    // 当前价格之上的单子 挂单价格 按平均持仓价格计算
                    upperSumPrice = upperSumPrice.add(avgPriceD);
                    // TODO: 如果是新开单的话，这个地方应该是要加手续费的
                }
                else {
                    // 当前价格之下（包含当前价格），按照下一格价格计算，最后一格不计算不挂单
                    const buyPrice = parseArr[j + 1];
                    upperSumPrice = upperSumPrice.add(buyPrice);
                    feeD = feeD.add(perVolumeD.mul(buyPrice).mul(feeRateD));
                }
            }
            // 平均持仓价格
            const avgPrice = upperSumPrice.div(sellOrderCount);
            const result = calculateLiquidation(totalBaseAmount.toString(), avgPrice.toString(), trend, assets, feeD.toString());
            /**
             * 做多
             * 例如：【3000,2900,2800, x,2700】x的下边的价格2700
             *
             * 做空
             * 例如：【2700,2800,2900, x,3000】x的下边的价格3000
             */
            const nextPrice = i >= parseArr.length - 1 ? 0 : parseArr[i + 1];
            if (nextPrice) {
                if (Number(result || 0)) {
                    if (isLong) {
                        // 做多 大于更小的各自则返回，否则爆仓价还在下边
                        if (new trade_utils_lib_1.SafeDecimal(result).greaterThan(new trade_utils_lib_1.SafeDecimal(nextPrice))) {
                            return result.toString();
                        }
                    }
                    else {
                        if (new trade_utils_lib_1.SafeDecimal(result).lessThan(new trade_utils_lib_1.SafeDecimal(nextPrice))) {
                            return result.toString();
                        }
                    }
                }
                continue;
            }
            else {
                return result.toString();
            }
        }
        return "";
    }
    GridV4FuturesProcessor.calculateGridLiquidationPrice = calculateGridLiquidationPrice;
    function processLiquidNoTrendPriceDisplay(upLiqui, downLiqui, precision) {
        const res = {
            upLiqui: "",
            downLiqui: "",
        };
        if (!GridV4FuturesProcessor.isNilOrEmpty(upLiqui)) {
            res.upLiqui = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(upLiqui, precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        }
        if (!GridV4FuturesProcessor.isNilOrEmpty(downLiqui)) {
            res.downLiqui = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(downLiqui, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        }
        return res;
    }
    GridV4FuturesProcessor.processLiquidNoTrendPriceDisplay = processLiquidNoTrendPriceDisplay;
    function processLiquiPriceDisplay(trend, upLiqui, downLiqui, precision) {
        if (trend === "long" && !GridV4FuturesProcessor.isNilOrEmpty(downLiqui)) {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(downLiqui, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        }
        else if (trend === "short" && !GridV4FuturesProcessor.isNilOrEmpty(upLiqui)) {
            return trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(upLiqui, precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR);
        }
        return "";
    }
    GridV4FuturesProcessor.processLiquiPriceDisplay = processLiquiPriceDisplay;
    GridV4FuturesProcessor.isNilOrEmpty = (price) => {
        return price === null || price === undefined || price === "";
    };
    GridV4FuturesProcessor.normalizeLiqPrice = ($st, originalPrice, quoteDisplay) => {
        if (!GridV4FuturesProcessor.isNilOrEmpty(originalPrice)) {
            if (new trade_utils_lib_1.SafeDecimal(originalPrice).lessThanOrEqualTo(0)) {
                return $st("gf_safe_label");
            }
            else {
                return (originalPrice !== null && originalPrice !== void 0 ? originalPrice : "--") + (quoteDisplay ? ` ${quoteDisplay}` : "");
            }
        }
        else {
            return "--" + (quoteDisplay ? ` ${quoteDisplay}` : "");
        }
    };
    GridV4FuturesProcessor.getAdjustParamsOptions = ({ top, bottom, row, checkInfo, balance, exchangeOrder, previousPrice, $st, symbolInfo, }) => __awaiter(this, void 0, void 0, function* () {
        var _a;
        const nextParams = {
            optionInfos: [],
            errorMsg: "",
        };
        const innerOrder = TradeAPILib_1.TradeUtils.getInnerOrder(exchangeOrder);
        const totalP = new trade_utils_lib_1.SafeDecimal(innerOrder.totalProfit);
        if (totalP.lt(0)) {
            // 直接修改
            nextParams.optionInfos.push({
                estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                estimate_liquidation_price_up_after: checkInfo.estimate_liquidation_price_up_after,
                estimate_liquidation_price_down_after: checkInfo.estimate_liquidation_price_down_after,
                estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                estimate_arithmetic_arbitrage_after: checkInfo.estimate_arithmetic_arbitrage_after,
                estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                estimate_geometric_arbitrage_min_after: checkInfo.estimate_geometric_arbitrage_min_after,
                estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                estimate_geometric_arbitrage_max_after: checkInfo.estimate_geometric_arbitrage_max_after,
                estimate_arbitrage_ratio: checkInfo.estimate_arbitrage_ratio,
                return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                return_open_price_total_profit_after: checkInfo.return_open_price_total_profit_after,
                actionType: _1.AdjustParamsActionType.Direct,
                totalProfit: totalP.toFixed(),
                errorMsg: checkInfo.reason === _1.AdjustParamsCheckReason.LESS_THAN_MIN_INVESTMENT
                    ? $st("grid_futures_adjust_params_option_without_enough_investment")
                    : undefined,
                isReinvest: true,
            });
            if (checkInfo.recommend) {
                const recommendExtraMargin = new trade_utils_lib_1.SafeDecimal(checkInfo.recommend.estimate_extra_margin);
                // 如果 recommendExtraMargin  > 0 则当前推荐参数为第三个选项。
                if (recommendExtraMargin.gt(0)) {
                    // 第二个选项则需要重新调用check获取
                    try {
                        const req = {
                            orderId: exchangeOrder.id,
                            type: _1.AdjustParamsType.adjust_params,
                            extra_margin: false,
                            quote_investment: checkInfo.recommend.estimate_investment || "0",
                            open_price: previousPrice + "",
                            bottom: bottom,
                            top: top,
                            row: new trade_utils_lib_1.SafeDecimal(row).toNumber(),
                            extra_margin_amount: "0",
                            is_reinvest: true,
                        };
                        const res = yield (0, rxjs_1.firstValueFrom)((0, useAdjustParamsCheckInfo_1.checkAdjustParams)(req, symbolInfo.precisionCost));
                        const isNotEnoughBalance = new trade_utils_lib_1.SafeDecimal(checkInfo.recommend.estimate_investment).gt(new trade_utils_lib_1.SafeDecimal(balance));
                        nextParams.optionInfos.push({
                            investment: res.estimate_investment,
                            estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                            estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                            estimate_liquidation_price_up_after: res.estimate_liquidation_price_up_after,
                            estimate_liquidation_price_down_after: res.estimate_liquidation_price_down_after,
                            estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                            estimate_arithmetic_arbitrage_after: res.estimate_arithmetic_arbitrage_after,
                            estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                            estimate_geometric_arbitrage_min_after: res.estimate_geometric_arbitrage_min_after,
                            estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                            estimate_geometric_arbitrage_max_after: res.estimate_geometric_arbitrage_max_after,
                            estimate_arbitrage_ratio: res.estimate_arbitrage_ratio,
                            return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                            return_open_price_total_profit_after: res.return_open_price_total_profit_after,
                            actionType: _1.AdjustParamsActionType.WithInvestment,
                            errorMsg: isNotEnoughBalance ? $st("available_balance_not_enough") : undefined,
                            totalProfit: totalP.toFixed(),
                            isReinvest: true,
                        });
                    }
                    catch (e) {
                        nextParams.optionInfos.length = 0;
                        nextParams.errorMsg = $st("request_fail_content");
                        return nextParams;
                    }
                    // 第三个选项中补充保证金大于当前币对精度时才展示第三个方案
                    const recommendExtraAfterPrecision = recommendExtraMargin.toFixed((_a = symbolInfo.precisionCost) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_DOWN);
                    if (new trade_utils_lib_1.SafeDecimal(recommendExtraAfterPrecision).gt(0)) {
                        // 第三个选项不需要重新调用check，直接获取数据即可
                        const isNotEnoughBalanceWithExtraMargin = new trade_utils_lib_1.SafeDecimal(checkInfo.recommend.estimate_investment)
                            .add(checkInfo.recommend.estimate_extra_margin)
                            .gt(new trade_utils_lib_1.SafeDecimal(balance));
                        nextParams.optionInfos.push({
                            investment: checkInfo.recommend.estimate_investment,
                            extraMargin: checkInfo.recommend.estimate_extra_margin,
                            estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                            estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                            estimate_liquidation_price_up_after: checkInfo.recommend.estimate_extra_liquidation_price_up_after,
                            estimate_liquidation_price_down_after: checkInfo.recommend.estimate_extra_liquidation_price_down_after,
                            estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                            estimate_arithmetic_arbitrage_after: checkInfo.recommend.estimate_arithmetic_arbitrage_after,
                            estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                            estimate_geometric_arbitrage_min_after: checkInfo.recommend.estimate_geometric_arbitrage_min_after,
                            estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                            estimate_geometric_arbitrage_max_after: checkInfo.recommend.estimate_geometric_arbitrage_max_after,
                            estimate_arbitrage_ratio: checkInfo.recommend.estimate_arbitrage_ratio,
                            return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                            return_open_price_total_profit_after: checkInfo.recommend.return_open_price_total_profit_after,
                            actionType: _1.AdjustParamsActionType.WithInvestmentAndMargin,
                            totalProfit: totalP.toFixed(),
                            errorMsg: isNotEnoughBalanceWithExtraMargin ? $st("available_balance_not_enough") : undefined,
                            isReinvest: true,
                        });
                    }
                }
                else {
                    // 当推荐参数中的Extra Margin没有额外保证金时, 第二个选项不需要重新调用check，直接获取数据即可
                    const isNotEnoughBalanceWithExtraMargin = new trade_utils_lib_1.SafeDecimal(checkInfo.recommend.estimate_investment).gt(new trade_utils_lib_1.SafeDecimal(balance));
                    nextParams.optionInfos.push({
                        investment: checkInfo.recommend.estimate_investment,
                        extraMargin: checkInfo.recommend.estimate_extra_margin,
                        estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                        estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                        estimate_liquidation_price_up_after: checkInfo.recommend.estimate_liquidation_price_up_after,
                        estimate_liquidation_price_down_after: checkInfo.recommend.estimate_liquidation_price_down_after,
                        estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                        estimate_arithmetic_arbitrage_after: checkInfo.recommend.estimate_arithmetic_arbitrage_after,
                        estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                        estimate_geometric_arbitrage_min_after: checkInfo.recommend.estimate_geometric_arbitrage_min_after,
                        estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                        estimate_geometric_arbitrage_max_after: checkInfo.recommend.estimate_geometric_arbitrage_max_after,
                        estimate_arbitrage_ratio: checkInfo.recommend.estimate_arbitrage_ratio,
                        return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                        return_open_price_total_profit_after: checkInfo.recommend.return_open_price_total_profit_after,
                        actionType: _1.AdjustParamsActionType.WithInvestment,
                        totalProfit: totalP.toFixed(),
                        errorMsg: isNotEnoughBalanceWithExtraMargin ? $st("available_balance_not_enough") : undefined,
                        isReinvest: true,
                    });
                }
            }
        }
        else {
            if (totalP.gt(0)) {
                // 不复投选项
                // 需要请求网络获取复投场景的checkInfo
                try {
                    const req = {
                        orderId: exchangeOrder.id,
                        type: _1.AdjustParamsType.adjust_params,
                        extra_margin: false,
                        quote_investment: "0",
                        open_price: previousPrice + "",
                        bottom: bottom,
                        top: top,
                        row: new trade_utils_lib_1.SafeDecimal(row).toNumber(),
                        extra_margin_amount: "0",
                        is_reinvest: false,
                    };
                    const res = yield (0, rxjs_1.firstValueFrom)((0, useAdjustParamsCheckInfo_1.checkAdjustParams)(req, symbolInfo.precisionCost));
                    nextParams.optionInfos.push({
                        estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                        estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                        estimate_liquidation_price_up_after: res.estimate_liquidation_price_up_after,
                        estimate_liquidation_price_down_after: res.estimate_liquidation_price_down_after,
                        estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                        estimate_arithmetic_arbitrage_after: res.estimate_arithmetic_arbitrage_after,
                        estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                        estimate_geometric_arbitrage_min_after: res.estimate_geometric_arbitrage_min_after,
                        estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                        estimate_geometric_arbitrage_max_after: res.estimate_geometric_arbitrage_max_after,
                        estimate_arbitrage_ratio: res.estimate_arbitrage_ratio,
                        return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                        return_open_price_total_profit_after: res.return_open_price_total_profit_after,
                        actionType: _1.AdjustParamsActionType.ProfitDirect,
                        totalProfit: totalP.toFixed(),
                        isReinvest: false,
                        errorMsg: res.reason === _1.AdjustParamsCheckReason.LESS_THAN_MIN_INVESTMENT
                            ? $st("grid_futures_less_min_investment")
                            : undefined,
                    });
                }
                catch (e) {
                    nextParams.optionInfos.length = 0;
                    nextParams.errorMsg = $st("request_fail_content");
                    return nextParams;
                }
                // 复投
                nextParams.optionInfos.push({
                    estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                    estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                    estimate_liquidation_price_up_after: checkInfo.estimate_liquidation_price_up_after,
                    estimate_liquidation_price_down_after: checkInfo.estimate_liquidation_price_down_after,
                    estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                    estimate_arithmetic_arbitrage_after: checkInfo.estimate_arithmetic_arbitrage_after,
                    estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                    estimate_geometric_arbitrage_min_after: checkInfo.estimate_geometric_arbitrage_min_after,
                    estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                    estimate_geometric_arbitrage_max_after: checkInfo.estimate_geometric_arbitrage_max_after,
                    estimate_arbitrage_ratio: checkInfo.estimate_arbitrage_ratio,
                    return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                    return_open_price_total_profit_after: checkInfo.return_open_price_total_profit_after,
                    actionType: _1.AdjustParamsActionType.ProfitWithInvestment,
                    totalProfit: totalP.toFixed(),
                    isReinvest: true,
                    errorMsg: checkInfo.reason === _1.AdjustParamsCheckReason.GREATE_THAN_MAX_INVESTMENT
                        ? $st("grid_futures_exceed_max_available_investment")
                        : undefined,
                });
            }
            else {
                // 直接修改
                nextParams.optionInfos.push({
                    estimate_liquidation_price_up: checkInfo.estimate_liquidation_price_up,
                    estimate_liquidation_price_down: checkInfo.estimate_liquidation_price_down,
                    estimate_liquidation_price_up_after: checkInfo.estimate_liquidation_price_up_after,
                    estimate_liquidation_price_down_after: checkInfo.estimate_liquidation_price_down_after,
                    estimate_arithmetic_arbitrage: checkInfo.estimate_arithmetic_arbitrage,
                    estimate_arithmetic_arbitrage_after: checkInfo.estimate_arithmetic_arbitrage_after,
                    estimate_geometric_arbitrage_min: checkInfo.estimate_geometric_arbitrage_min,
                    estimate_geometric_arbitrage_min_after: checkInfo.estimate_geometric_arbitrage_min_after,
                    estimate_geometric_arbitrage_max: checkInfo.estimate_geometric_arbitrage_max,
                    estimate_geometric_arbitrage_max_after: checkInfo.estimate_geometric_arbitrage_max_after,
                    estimate_arbitrage_ratio: checkInfo.estimate_arbitrage_ratio,
                    return_open_price_total_profit: checkInfo.return_open_price_total_profit,
                    return_open_price_total_profit_after: checkInfo.return_open_price_total_profit_after,
                    actionType: _1.AdjustParamsActionType.ProfitDirect,
                    totalProfit: totalP.toFixed(),
                    isReinvest: true,
                });
            }
        }
        return nextParams;
    });
    GridV4FuturesProcessor.useQuoteToUInfo = ({ symbol, investCoin, mode = TradeAPILib_1.GridFuturesMode.normal, } = {}, isActive = true) => {
        var _a;
        const needTransfer = (_a = (symbol && symbol.quote !== USDT && investCoin === USDT && mode === TradeAPILib_1.GridFuturesMode.normal)) !== null && _a !== void 0 ? _a : false;
        const quoToUSymbol = needTransfer ? (0, trade_utils_lib_1.getTradeDependencyInstance)().getSymbolInfo(`${symbol === null || symbol === void 0 ? void 0 : symbol.quote}/${USDT}`) : undefined;
        const quoteToUTicker = (0, trade_quotation_lib_1.useTicker)({ base: quoToUSymbol === null || quoToUSymbol === void 0 ? void 0 : quoToUSymbol.base, quote: quoToUSymbol === null || quoToUSymbol === void 0 ? void 0 : quoToUSymbol.quote, isActive: needTransfer && isActive });
        const price = (0, react_1.useMemo)(() => {
            var _a;
            if (!needTransfer) {
                return;
            }
            return new trade_utils_lib_1.SafeDecimal(quoteToUTicker === null || quoteToUTicker === void 0 ? void 0 : quoteToUTicker.latest).toDP((_a = quoToUSymbol === null || quoToUSymbol === void 0 ? void 0 : quoToUSymbol.precision) !== null && _a !== void 0 ? _a : 2).toString();
        }, [needTransfer, quoToUSymbol === null || quoToUSymbol === void 0 ? void 0 : quoToUSymbol.precision, quoteToUTicker === null || quoteToUTicker === void 0 ? void 0 : quoteToUTicker.latest]);
        return {
            needTransfer,
            quoToUSymbol,
            quoteToUPrice: price,
        };
    };
    // 当用户选择自动预留保证金投U时，根据check返回的币的数据，用户输入的U的数据，计算投资额 和 额外保证金的分配比例
    // 投资额的比例 = 投资额/(投资额+额外保证金) (备注：tradeInfo.estimateTradeInvest: 这个字段代表投资额，并且是已经包含了手续费的)
    // 按U的实际投资额 = U的总投资额 * 投资额的比例
    // 按U的额外保证金 = U的总投资额 - 按U的实际投资额
    GridV4FuturesProcessor.getInvestAndExtraMarginBaseU = (tradeInfo, investU, precisionCost) => {
        const estimateTradeInvest = new trade_utils_lib_1.SafeDecimal(tradeInfo.estimateTradeInvest);
        const estimateMarginInvest = new trade_utils_lib_1.SafeDecimal(tradeInfo.estimateMarginInvest);
        const userInputInvest = new trade_utils_lib_1.SafeDecimal(investU);
        const estimateTotal = estimateTradeInvest.add(estimateMarginInvest);
        const resInvestU = userInputInvest
            .mul(estimateTradeInvest.div(estimateTotal))
            .toDecimalPlaces(precisionCost !== null && precisionCost !== void 0 ? precisionCost : 2, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
            .toFixed();
        const resExtraMarginU = userInputInvest.minus(new trade_utils_lib_1.SafeDecimal(resInvestU)).toFixed();
        return [resInvestU, resExtraMarginU];
    };
    function checkGridFuturesExceedingCloseOrderBV(exchangeOrder, stableQuote, bigVolume, ticker, quoteTicker) {
        var _a, _b, _c;
        const innerOrder = exchangeOrder.exchangeGridV4FuturesOrder;
        if (exchangeOrder.orderType !== TradeAPILib_1.ExchangeOrderType.gridV4Futures || !innerOrder || !ticker) {
            return false;
        }
        const { base } = exchangeOrder;
        const coinBase = (_a = base.split(".")[0]) !== null && _a !== void 0 ? _a : base;
        const { position } = innerOrder;
        if (stableQuote) {
            const v = new trade_utils_lib_1.SafeDecimal(position).abs().mul(new trade_utils_lib_1.SafeDecimal(ticker.latest));
            const target = new trade_utils_lib_1.SafeDecimal((_b = bigVolume[coinBase]) !== null && _b !== void 0 ? _b : bigVolume.DEFAULT);
            return v.gt(target);
        }
        else {
            if (!quoteTicker) {
                return false;
            }
            const v = new trade_utils_lib_1.SafeDecimal(position).abs().mul(new trade_utils_lib_1.SafeDecimal(ticker.latest));
            const midTarget = v.mul(new trade_utils_lib_1.SafeDecimal(quoteTicker.latest));
            const target = new trade_utils_lib_1.SafeDecimal((_c = bigVolume[coinBase]) !== null && _c !== void 0 ? _c : bigVolume.DEFAULT);
            return midTarget.gt(target);
        }
    }
    GridV4FuturesProcessor.checkGridFuturesExceedingCloseOrderBV = checkGridFuturesExceedingCloseOrderBV;
    GridV4FuturesProcessor.DEFAULT_GRID_FUTURES_CLOSE_ORDER_BIG_VOLUME_CONFIG = {
        BTC: 1000000,
        ETH: 1000000,
        SOL: 200000,
        DEFAULT: 100000,
    };
    function processOriginInvestRange(tradeInfo, balance, precision) {
        const min = (tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.min_investment)
            ? trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(tradeInfo.min_investment, precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
            : "0";
        const max = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(balance), new trade_utils_lib_1.SafeDecimal(tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.max_investment)), precision);
        return { min, max };
    }
    function processInputInvestRange(symbolInfo, tradeInfo, quoteToUInfo) {
        var _a, _b, _c, _d;
        if (!tradeInfo) {
            return ["0", "0"];
        }
        const quoteInvestMin = new trade_utils_lib_1.SafeDecimal(tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.min_investment).toDP((_a = symbolInfo.precisionCost) !== null && _a !== void 0 ? _a : 2, trade_utils_lib_1.SafeDecimal.ROUND_CEIL);
        const quoteInvestMax = new trade_utils_lib_1.SafeDecimal(tradeInfo === null || tradeInfo === void 0 ? void 0 : tradeInfo.max_investment).toDP((_b = symbolInfo.precisionCost) !== null && _b !== void 0 ? _b : 2);
        if (quoteToUInfo === null || quoteToUInfo === void 0 ? void 0 : quoteToUInfo.needTransfer) {
            const precision = (_d = (_c = quoteToUInfo.quoToUSymbol) === null || _c === void 0 ? void 0 : _c.precisionCost) !== null && _d !== void 0 ? _d : 2;
            const minV = quoteInvestMin
                .mul(new trade_utils_lib_1.SafeDecimal(quoteToUInfo.quoteToUPrice).mul(exports.PriceCoefficient)) // 价格上浮冗余值
                .toDP(precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
                .toFixed();
            const maxV = quoteInvestMax
                .mul(new trade_utils_lib_1.SafeDecimal(quoteToUInfo.quoteToUPrice).div(exports.PriceCoefficient)) // 价格下浮冗余值
                .toDP(precision, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                .toFixed();
            return [minV, maxV];
        }
        return [quoteInvestMin.toFixed(), quoteInvestMax.toFixed()];
    }
    function adjustPrice(price) {
        return new trade_utils_lib_1.SafeDecimal(price).mul(exports.PriceCoefficient);
    }
    GridV4FuturesProcessor.adjustPrice = adjustPrice;
    function calcMinQuote(origin, price) {
        return new trade_utils_lib_1.SafeDecimal(origin).mul(adjustPrice(price)).toString();
    }
    GridV4FuturesProcessor.calcMinQuote = calcMinQuote;
    function calcMaxQuote(origin, price, max) {
        return trade_utils_lib_1.SafeDecimal.min(new trade_utils_lib_1.SafeDecimal(origin).mul(new trade_utils_lib_1.SafeDecimal(price).div(exports.PriceCoefficient)), new trade_utils_lib_1.SafeDecimal(max)).toString();
    }
    GridV4FuturesProcessor.calcMaxQuote = calcMaxQuote;
})(GridV4FuturesProcessor || (exports.GridV4FuturesProcessor = GridV4FuturesProcessor = {}));
